import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { WaitlistForm } from "./WaitlistForm";

const WaitlistContext = createContext({ open: () => {} });

export const useWaitlist = () => useContext(WaitlistContext);

/**
 * Global waitlist dialog. Any CTA calls `open(source)`; the source is stored with the signup.
 */
export const WaitlistProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, source: "landing" });
  const open = useCallback((source = "landing") => setState({ open: true, source }), []);
  const value = useMemo(() => ({ open }), [open]);

  return (
    <WaitlistContext.Provider value={value}>
      {children}
      <Dialog open={state.open} onOpenChange={(o) => setState((s) => ({ ...s, open: o }))}>
        <DialogContent
          data-testid="waitlist-dialog"
          className="axt-glass axt-noise max-w-lg p-7 sm:p-9 border-white/20 bg-black/85 rounded-sm text-[color:var(--axt-text)] [&>button]:text-white/60 [&>button]:hover:text-white [&>button]:rounded-sm [&>button]:focus:ring-1 [&>button]:focus:ring-white/70 [&>button]:focus:ring-offset-0"
        >
          <DialogHeader className="text-left space-y-0">
            <p className="axt-rule mb-4">
              <span>Waitlist · 2026 cohort</span>
            </p>
            <DialogTitle className="font-display text-3xl sm:text-4xl leading-[1.05] tracking-[-0.02em] font-normal text-[color:var(--axt-text)]">
              Join the waitlist.
            </DialogTitle>
            <DialogDescription className="pt-3 text-sm sm:text-base leading-relaxed text-[color:var(--axt-text-dim)]">
              Axtara is onboarding a limited number of funds in 2026. Leave your email and a senior fund accountant will reach out when your slot
              opens.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-4">
            <WaitlistForm source={state.source} compact idPrefix="dlg" />
          </div>
        </DialogContent>
      </Dialog>
    </WaitlistContext.Provider>
  );
};
